import React from 'react';

/**
 * Collapsible sidebar card. `open` is controlled by the container so a failed
 * save can force the card holding the offending field open before scrolling.
 *   <SidebarCard id="details" title="Details" open={open} onToggle={fn} badge={<Badge/>}>…</SidebarCard>
 */
export default function SidebarCard({ id, title, open = true, onToggle, badge, children }) {
  const bodyId = `${id}-body`;
  return (
    <section className="card" id={`${id}-card`} aria-labelledby={`${id}-title`}>
      <div className="card-header" style={{ marginBottom: open ? 12 : 0 }}>
        <h3 className="card-title" id={`${id}-title`} style={{ margin: 0 }}>
          <button
            type="button"
            className="btn btn-ghost btn-sm"
            aria-expanded={open}
            aria-controls={bodyId}
            onClick={onToggle}
            style={{
              padding: '2px 4px',
              font: 'inherit',
              textTransform: 'inherit',
              letterSpacing: 'inherit',
              color: 'inherit',
              display: 'inline-flex',
              gap: 6,
              alignItems: 'center',
            }}
          >
            <span aria-hidden="true" style={{ display: 'inline-block', width: 10, fontSize: 10 }}>{open ? '▼' : '▶'}</span>
            {title}
          </button>
        </h3>
        {badge}
      </div>
      <div id={bodyId} hidden={!open}>
        {children}
      </div>
    </section>
  );
}
